import { useState } from "react"
import Player from "./RoosterPlayer"
import styled from "styled-components"
import EmptyPlayer from "./EmptyPlayer"
import ClubInfo from "./ClubInfo"
import ManagersArea from "./ManagersArea"
import { useLeague } from "../../../context/useLeague"
import { useUser } from "../../../context/useUser"
import useNotfy from "../../../context/useNotify"
import helperService from "../../../services/helper"
import teamService from "../../../services/team"
import { User } from "../../../models/user"
import ConfirmationModalContent from "../../common/ConfirmationModalContent"
import ReactModal from "../../common/ReactModal"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faExchangeAlt, faSpinner } from "@fortawesome/free-solid-svg-icons"
import leagueService from "../../../services/league"

const Roster = ({}) => {
  const notfy = useNotfy()
  const { user } = useUser()
  const { league, userRoster, userTeam, manager, getLeagueById, setTeamHubLeague } = useLeague()

  // Data
  const [showContractsInfo, setShowContractsInfo] = useState(false)
  const [showReleasePlayerButton, setShowReleasePlayerButton] = useState(false)

  const [isLoading, setIsLoading] = useState(false);

  // Api
  const removeTeamUser = async (userId: string) => {
    if (!userTeam) {
      return
    }
    try {
      await teamService.releasePlayer(userTeam._id, userId)
      notfy.success("Player removed from team")
    } catch (error) {
      console.log(error)
      helperService.showNotfyErr(notfy, error, "Error removing user from team")
    } finally {
      fetchLeague()
    }
  }

  const fetchLeague = async () => {
    if (!league) {
      return
    }
    await getLeagueById(league?._id)
  }

  // Methods
  const handleClickShowContractsInfo = () => {
    setShowContractsInfo(!showContractsInfo)
  }

  const handleClickShowRemovePlayer = () => {
    setShowReleasePlayerButton(!showReleasePlayerButton)
  }

  const handleSwitchLeagueClick = async () => {
    if (!user || !league || !user.leagues.length) {
      return;
    }
    setIsLoading(true);
    const currentLeagueIndex = user.leagues.indexOf(league._id);
    const nextLeagueIndex = (currentLeagueIndex + 1) % user.leagues.length;
    const nextLeagueId = user.leagues[nextLeagueIndex];
    try {
      const nextLeague = await leagueService.getTeamHubLeague(nextLeagueId);
      setTeamHubLeague(nextLeague);
    } catch (error) {
      console.error("Error fetching next league:", error);
      notfy.error("Error switching league. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  // Modals
  const [selectedUser, setSelectedUser] = useState<User | null>()

  const closeModals = () => {
    setSelectedUser(null)
    setShowReleasePlayerModal(false)
  }

  // Modal release player
  const [showReleasePlayerModal, setShowReleasePlayerModal] = useState(false)

  const handleShowReleasePlayerModal = (user: User) => {
    setSelectedUser(user)
    setShowReleasePlayerModal(true)
  }

  const handleClickReleasePlayer = async () => {
    if (selectedUser) {
      await removeTeamUser(selectedUser._id)
    }
    closeModals()
  }

  return (
    <>
      {league ? (
        <>
          <div className="container-fluid m-0 p-0 mb-3 d-flex justify-content-center flex-column align-items-center">
            {/* Switch leagues */}
            {user && user.leagues.length > 1 ? (
              <GridContainer className="d-flex justify-content-end me-4 mb-2">
                <button
                  className="btn btn-dark d-flex align-items-center"
                  onClick={handleSwitchLeagueClick}
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <FontAwesomeIcon icon={faSpinner} spin className="me-2" />
                  ) : (
                    <FontAwesomeIcon icon={faExchangeAlt} className="me-2" />
                  )}
                  {isLoading ? "Switching..." : `Switch League`}
                </button>
              </GridContainer>
          ) : null}
            {/* club info */}
            {userTeam && league ? (
              <ClubInfo
                teamName={userTeam.name}
                managerName={userTeam.manager}
                LiveLink={userTeam.liveLink}
                clubImage={userTeam.image}
                league={league}
              />
            ) : null}
            {/* players in roster */}
            <GridContainer className="row p-0  m-0 ">
              {userRoster.map((player, i) => (
                <div className="col-lg-2 col-md-3 col-4" key={i}>
                  <Player
                    player={player}
                    showReleasePlayerButton={showReleasePlayerButton}
                    showContractsInfo={showContractsInfo}
                    handleShowReleasePlayerModal={handleShowReleasePlayerModal}
                  />
                </div>
              ))}
              {[...new Array(24 - userRoster.length)].map((player, i) => (
                <div className="col-lg-2 col-md-3 col-4" key={i}>
                  <EmptyPlayer />
                </div>
              ))}
            </GridContainer>
            {/* managers area */}
            {manager && user && manager._id === user._id ? (
              <GridContainer className="row p-0  m-0  d-flex justify-content-start align-items-end flex-column  mt-4 ">
                <ManagersArea
                  handleClickRelease={handleClickShowRemovePlayer}
                  handleClickContractsInfo={handleClickShowContractsInfo}
                />
              </GridContainer>
            ) : null}
          </div>
        </>
      ) : null}

      {/* Release Player Modal */}
      <ReactModal
        modalOpen={showReleasePlayerModal}
        component={
          <ConfirmationModalContent
            onConfirm={handleClickReleasePlayer}
            onCancel={() => closeModals()}
            message={`Are you sure you want to release ${selectedUser?.username}?`}
          />
        }
        closeModal={() => closeModals()}
      />
    </>
  )
}

export default Roster

const GridContainer = styled.div`
  @media (max-width: 575px) {
    padding: 0 1rem;
  }
  max-width: 800px;
  width: 100%;
`
